import { invert } from 'lodash-es';
import { OS_TYPE } from '../../../components/StatelessComponent/SingleFilter/OperatingSystemFilter/OperatingSystemType';
import type { IntermediateFormat } from '../../../domains/global-filters/model/IntermediateFormat';
import type { QueryFormatFilter } from '../../../domains/global-filters/model/QueryFormat';
import { QueryKeyEnum } from '../../../domains/global-filters/model/QueryFormat';
import * as ShortStringListConverter from './GenericConverter/ShortStringListConverter';

const queryValueByUiValue: Record<OS_TYPE, string> = {
  [OS_TYPE.WINDOWS]: 'Windows',
  [OS_TYPE.MAC]: 'Mac',
  [OS_TYPE.LINUX]: 'Linux',
  [OS_TYPE.UBUNTU]: 'Ubuntu',
  [OS_TYPE.ANDROID]: 'Android',
  [OS_TYPE.IOS]: 'iOS',
};

const uiValueByQueryValue = invert(queryValueByUiValue) as Record<string, OS_TYPE>;

export function fromUiToQueryFormat(uiValue?: OS_TYPE[]): QueryFormatFilter {
  if (!uiValue) {
    throw new Error(`uiValue is undefined`);
  }
  return ShortStringListConverter.fromUiToQueryFormat(
    uiValue,
    QueryKeyEnum.os,
    queryValueByUiValue,
  );
}

export function fromIntermediateToUiFormat(intermediateValue: IntermediateFormat): OS_TYPE[] {
  return ShortStringListConverter.fromIntermediateToUiFormat(
    intermediateValue,
    uiValueByQueryValue,
  );
}
